import crypto from 'crypto';

/**
 * Generates a hashed identity value from a given plain text identity.
 * The hashing process involves multiple iterations of SHA-256 hashing
 * and concatenation of intermediate results.
 *
 * @param {string} identityInPlainText - The plain text identity to be hashed.
 * @returns {string} - The final hashed identity value in base64 format.
 */
// STRAT GENAI@COPILOT
// This function takes a plain text identity as input and returns a hashed identity value.
export const generateHashedIdentityValue = (identityInPlainText: string) => {
  // Convert to lowercase and get bytes
  const identityInLowerCase = identityInPlainText.toLowerCase();
  let currentHashValue = Buffer.from(identityInLowerCase, 'utf-8');

  // Perform 1000 iterations of SHA-256
  for (let i = 0; i < 1000; i++) {
    currentHashValue = crypto.createHash('sha256').update(currentHashValue).digest();
  }

  // Calculate intermediate hash
  const identityBytes = Buffer.from(identityInLowerCase, 'utf-8');
  const initialHash = crypto.createHash('sha256').update(identityBytes).digest();
  const intermediateHash = Buffer.concat([initialHash, currentHashValue]);

  // Final hash
  const finalHash = crypto.createHash('sha256').update(intermediateHash).digest();

  return finalHash.toString('base64');
};
// END GENAI@COPILOT
